export const PUBLIC_MOTION = {
  ease: [0.22, 1, 0.36, 1],
  duration: 0.65,
  stagger: 0.09,
  staggerHero: 0.1,
  staggerFaq: 0.032,
  staggerProcess: 0.07,
  staggerCard: 0.09,
  delayChildren: 0.04,
  delayHero: 0,
  viewportAmount: 0.15,
  // Animate position without blending text/badges into their background.
  tones: {
    hero: { opacity: 1, y: 32, blur: 0 },
    heroSoft: { opacity: 1, y: 22, blur: 3.5 },
    text: { opacity: 1, y: 28, blur: 0 },
    card: { opacity: 1, y: 32, blur: 0 },
    faq: { opacity: 1, y: 20, blur: 0 },
  },
};

export function resolveMotionFrom(tone = "text", y, fromOpacity, blur) {
  const preset = PUBLIC_MOTION.tones[tone] ?? PUBLIC_MOTION.tones.text;
  return {
    opacity: fromOpacity ?? preset.opacity,
    y: y ?? preset.y,
    filter: `blur(${blur ?? preset.blur ?? 0}px)`,
  };
}
